module.exports = __webpack_public_path__ + "static/img/model-bg.248b0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/model-bg.png
// module id = sOdC
// module chunks = 1